import React, { Component } from 'react';
import { TableCell } from '@mui/material';
import { fPercent } from '../../utils/formatNumber';

export default class GridPercentCell extends Component {
    //props: value, id, field
    render() {
        const formattedPercent = fPercent(this.props.value);
        const baseStyle = this.props.styles || {};
        return (
            <TableCell key={this.props.field.id} align="left" sx={{ ...baseStyle }}>
                {formattedPercent}
            </TableCell>
        );
    }
}
